export default "__VITE_ASSET__CCY61OUl__"